import * as React from 'react';
import { config } from 'src/services/google-maps/config';
import './LocationRender.scss';

class LocationFormatter extends React.Component<any> {
       
    render() {
        if (this.props.value) {
            return (this.getImage(this.props.value));
        } else {
            return 'No Location Set';
        }
    }

    getImage({lat, lng}: {lat: number, lng: number}) {
        const center = `${lat},${lng}`;
        let imageURL = `https://maps.googleapis.com/maps/api/staticmap?`;
        imageURL += `center=${center}`;
        imageURL += `&zoom=13&size=600x300`;
        imageURL += `&markers=color:red%7Clabel:L%7C${center}`;
        imageURL += `&key=${config.apiKey}`;
        return (
            <div 
                style={{
                    backgroundImage: `url('${imageURL}')`,
                    height: `${this.props.height}px`
                }} 
                
                className="map-image"
            />
        );
    }
}

export default function getLocationColumn(key: string, name?: string, height?: any) {
    return {
        key,
        name: name || 'Location',
        formatter: (props: {value: any}) => <LocationFormatter height={height || 35} {...props}/>
    };
}


// WEBPACK FOOTER //
// ./src/components/LocationRender.tsx